/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsFindOneReportRunsCatalogQueryResponse, AuditReportsFindOneReportRunsCatalogPathParams, AuditReportsFindOneReportRunsCatalog401, AuditReportsFindOneReportRunsCatalog403, AuditReportsFindOneReportRunsCatalog404 } from "../models/AuditReportsFindOneReportRunsCatalog";

export function getAuditReportsFindOneReportRunsCatalogUrl(id: AuditReportsFindOneReportRunsCatalogPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/report-runs/${id}` as const }
  return res
}

/**
 * @description Poll this after create until job.isFinished. Primary outputs are ready when every artifacts[] entry with role=primary has storageUri. Then GET /report-runs/{id}/artifacts/{kind} for a signed HTTPS URL (do not use gs:// storageUri in browsers). If generation failed, metadata.errorCode is GENERATION_FAILED. Tenant-scoped: other clients get 404.
 * @summary Get a report run by id
 * {@link /audit-reports/v1/report-runs/:id}
 */
export async function auditReportsFindOneReportRunsCatalog(id: AuditReportsFindOneReportRunsCatalogPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsFindOneReportRunsCatalogQueryResponse, ResponseErrorConfig<AuditReportsFindOneReportRunsCatalog401 | AuditReportsFindOneReportRunsCatalog403 | AuditReportsFindOneReportRunsCatalog404>, unknown>({ method : "GET", url : getAuditReportsFindOneReportRunsCatalogUrl(id).url.toString(), ... requestConfig })
  return res.data
}